// Indian number & date formatting helpers (Phase 1)

const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const inrCompactFormatter = new Intl.NumberFormat("en-IN", {
  maximumFractionDigits: 0,
});

export const formatINR = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return "—";
  return inrFormatter.format(amount);
};

// Indian lakh/crore shortening for very large sums (e.g. ₹4.85 Cr)
export const formatINRCompact = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return "—";
  if (amount >= 1_00_00_000) {
    return `₹${(amount / 1_00_00_000).toFixed(2)} Cr`;
  }
  if (amount >= 1_00_000) {
    return `₹${(amount / 1_00_000).toFixed(2)} L`;
  }
  return `₹${inrCompactFormatter.format(amount)}`;
};

// DD/MM/YYYY Indian date format
export const formatIndianDate = (input) => {
  if (!input) return "—";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

// DD MMM YYYY (e.g. 12 May 2026)
export const formatIndianDateLong = (input) => {
  if (!input) return "—";
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};
